  /*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import NativeBuilding from 'astro/react/map/entity/building.native';


export default ({ zone, ...props }) =>
{
  const building = zone.getEntity();
  const type = building.getCass().getVariant();

  if (building.getStatus().isCreate() || building.getStatus().isDisband())
  {
    return <NativeBuilding {...props} dashed type = {type} />;
  }

  if (building.getStatus().isUpgrade() || building.getStatus().isSetup() || building.getStatus().isActive())
  {
    return <NativeBuilding {...props} inverted type = {type} />;
  }

  return <NativeBuilding {...props} type = {type} />;
}
